import {} from '../../middleware/api/apiList'

import { createSlice } from '@reduxjs/toolkit'
import {
  SidebarMenu,
  SidebarMenuReturnApi,
  ValidationError,
} from '../../types/SidebarMenu/sidebarMenuType'
import {
  getSidebarMenu,
  getVendorSidebarMenu,
} from '../../middleware/api/SidebarMenu/sidebarMenuApi'
import { RootState } from '../../stateStore'

const initialSidebarMenuState: SidebarMenu = {
  menuItems: [] as SidebarMenuReturnApi[],
  error: null,
  isLoading: false,
}

const sidebarMenuSlice = createSlice({
  name: 'sidebarMenuSliceHandler', // name of your slice
  initialState: initialSidebarMenuState,
  reducers: {
    setSidebarMenuSliceHandler: (state, action) => {
      return { ...state, ...action.payload }
    },
    clearError: (state) => {
      state.error = null
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getSidebarMenu.pending, (state) => {
        state.isLoading = true
      })
      .addCase(getSidebarMenu.fulfilled, (state, action) => {
        state.menuItems = action.payload
      })
      .addCase(getSidebarMenu.rejected, (state, action) => {
        state.isLoading = false
        state.error = action.payload as ValidationError
      })
      .addCase(getVendorSidebarMenu.pending, (state) => {
        state.isLoading = true
      })
      .addCase(getVendorSidebarMenu.fulfilled, (state, action) => {
        state.menuItems = action.payload
      })
      .addCase(getVendorSidebarMenu.rejected, (state, action) => {
        state.isLoading = false
        state.error = action.payload as ValidationError
      })
  },
})

const getSidebarMenuItems = (state: RootState): SidebarMenuReturnApi[] => {
  return state.sidebarMenu.menuItems
}

const sideBarSelectors = { getSidebarMenuItems }
export const SidebarMenuSliceService = {
  actions: sidebarMenuSlice.actions,
  selectors: sideBarSelectors,
}
export default sidebarMenuSlice.reducer
